import { type ComponentProps, lazy, Suspense } from 'react'

// sonner injects a <style> tag the moment it is imported, so the shell and everything that toasts
// stay out of the eager route graph until someone opens Canvas.
const Shell = lazy(() =>
  import('./canvas-shell').then((module) => ({ default: module.CanvasShell })),
)
const CollectionsNav = lazy(() =>
  import('./canvas-shell').then((module) => ({
    default: module.CanvasCollectionsNav,
  })),
)

export function CanvasShell(props: ComponentProps<typeof Shell>) {
  return (
    <Suspense fallback={null}>
      <Shell {...props} />
    </Suspense>
  )
}

export function CanvasCollectionsNav(
  props: ComponentProps<typeof CollectionsNav>,
) {
  return (
    <Suspense fallback={null}>
      <CollectionsNav {...props} />
    </Suspense>
  )
}
